import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import dayjs from "dayjs";
import { atom, useRecoilValue } from "recoil";
import styled from "styled-components";
import Flex from "../../../../../../DefaultStyles/Flex";
import CalendarModal from "../../../../../../Modal/CalendarModal";
import { defaultModalScrollHeight } from "../../../../../../Modal/DefaultModalLayout";

interface RentPartyListProps {
  // d: string;
  modalType?: string;
  index: number;
  rentPartyList: string[];
  setRentPartyList: Dispatch<SetStateAction<string[]>>;
}

export default function RentPartyList({
  // d,
  modalType,
  index,
  rentPartyList,
  setRentPartyList,
}: RentPartyListProps) {
  const modalScrollHeight = useRecoilValue(defaultModalScrollHeight);

  const [pid, setPid] = useState("");
  const [uid, setUid] = useState("");
  const [date, setDate] = useState("");

  const [dateClick, setDateClick] = useState(false);

  useEffect(() => {
    if (pid !== "" || uid !== "" || date !== "") {
      let temp = rentPartyList;
      temp[index] = `${pid}_${uid}_${date}`;

      setRentPartyList(temp);
    }
  }, [pid, uid, date]);

  useEffect(() => {
    const d = rentPartyList[index];

    setPid(d !== "" ? d?.split("_")[0] : "");
    setUid(d !== "" ? d?.split("_")[1] : "");
    setDate(d?.split("_")[2]);
  }, [rentPartyList]);

  return (
    <LabelBoxContainer>
      <LabelBox>
        <Value
          type="number"
          inputMode="numeric"
          value={pid}
          onChange={(e) => {
            const value = (e.target as HTMLInputElement).value;
            setPid(value);
          }}
          readOnly={modalType === "view"}
          placeholder="직접 입력"
        />
      </LabelBox>

      <LabelBox>
        <Value
          type="number"
          inputMode="numeric"
          value={uid}
          onChange={(e) => {
            const value = (e.target as HTMLInputElement).value;
            setUid(value);
          }}
          readOnly={modalType === "view"}
          placeholder="직접 입력"
        />
      </LabelBox>

      <LabelBox style={{ position: "relative", width: "100%" }}>
        <Flex>
          <Value
            value={date}
            readOnly={modalType === "view"}
            placeholder="선택"
            // disabled={true}
          />

          <>
            {modalType !== "view" && (
              <DropdownIcon
                className="material-symbols-outlined"
                onClick={() => setDateClick(true)}
              >
                arrow_drop_down
              </DropdownIcon>
            )}
          </>
        </Flex>

        {dateClick && (
          <CalendarModal
            closeEvent={() => setDateClick(false)}
            changeEvent={(date: string) => setDate(date)}
            dateValue={
              date?.includes("Invalid")
                ? dayjs().format("YYYY-MM-DD")
                : date ?? dayjs().format("YYYY-MM-DD")
            }
            sPosition="fixed"
            sMarginTop={-(modalScrollHeight - 10)}
            sMarginLeft={"-16px"}
          />
        )}
      </LabelBox>

      {modalType === "edit" && (
        <DeleteBtn
          onClick={() => {
            let temp = rentPartyList;

            const a = temp.filter((d, i) => {
              console.log(d, i, index, i === index);

              return i !== index;
            });

            setRentPartyList(a);
          }}
        >
          <img
            src={require("../../../../../../../assets/remove_circle_black_24@2x.png")}
            alt="beta"
          />
        </DeleteBtn>
      )}
    </LabelBoxContainer>
  );
}

const LabelBoxContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;

  &:first-child {
    margin-top: 6px;
  }

  &:not(&:first-child) {
    margin-top: 10px;
  }
`;

export const LabelBox = styled.div`
  display: flex;
  align-items: center;
  height: 38px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 0px 16px;
`;

const Value = styled.input`
  margin-top: 4px;
  width: 100%;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 0;

  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.color.gray900};

  &:read-only {
    cursor: auto;
  }

  &:read-only,
  &::placeholder {
    color: #858c97;
  }
`;

const DeleteBtn = styled.button`
  width: 38px;
  height: 38px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

const DropdownIcon = styled.span`
  margin-left: 8px;
  cursor: pointer;
  font-size: 24px;
`;
